import React from "react";
import { UserTableProps, UserTableState } from "./models";
import {RouteComponentProps, withRouter} from "react-router-dom";

import { Box, Chip, IconButton, Stack, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";

import { UserRole } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


class UserTable extends React.Component<UserTableProps & RouteComponentProps<any>, UserTableState>
{
    private tableColumns: MRT_ColumnDef[];

    private getUserName = (row: any): string => {
      return `${row.original.name?? ""} ${row.original.surname?? ""}`
    }

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            userToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "ut-table-col-name",
                    message: "Nome"
                }),
                accessorKey: "value",
                Cell: ({ cell, row }) => {
                  return (
                    <Typography>{this.getUserName(row)}</Typography>
                  );
                },
            },
            {
              header: t({
                id: "ut-table-col-email",
                message: "Email"
              }),
              accessorKey: "email",
              Cell: ({ cell }) => {
                return (
                    <Box>
                        {cell.getValue<string>()}
                    </Box>
                );
              },
            },
            {
              header: t({
                id: "ut-table-col-role",
                message: "Ruolo"
              }),
              accessorKey: "role",
              Cell: ({ cell }) => {

                let value = cell.getValue<UserRole>();

                return (
                  <Box>
                    {value === UserRole.END_USER && <Chip avatar={<AccountCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-end-user",
                      message: "Utente"
                    })} color="success" />}
                    {value === UserRole.PRODUCER && <Chip avatar={<AccountCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-producer",
                      message: "Produttore"
                    })} color="error" />}
                    {value === UserRole.ADMIN && <Chip avatar={<SupervisedUserCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-admin",
                      message: "Admin"
                    })} color="warning" />}
                    {value === UserRole.CHIEF_PRODUCER && <Chip avatar={<AccountCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-chief-producer",
                      message: "Capo produttore"
                    })} color="warning" />}
                    {value === UserRole.GUEST && <Chip avatar={<AccountCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-guest",
                      message: "Ospite"
                    })} color="info" />}
                    {value === UserRole.ANALYST && <Chip avatar={<AccountCircleIcon style={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />} label={t({
                      id: "ut-table-col-role-analyst",
                      message: "Analista"
                    })} color="warning" />}
                  </Box>
                );
              },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            userToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            userToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteUser();
    }

    private deleteUser = (): void => {
        this.props.deleteUser(this.state.userToDelete);
        this.setState(() => ({
            userToDelete: ""
        }))
    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private goEdit = (row: any): void => {
      let { history } = this.props
      history.push(`/backoffice/edit-user/${this.getIdValue(row)}`);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }    

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalUserCount}
                    pageCount={Math.ceil(this.props.totalUserCount / this.props.pagination.pageSize)}
                    data={this.props.users}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.goEdit(row)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
        {this.state.openConfirmModal && <ConfirmModal
            cancelConfirmCallback={this.cancelConfirmModalCallback}
            confirmCallback={this.acceptConfirmModal}
            text={"Sei sicuro di voler eliminare l'utente?"}
            textId={"ut-delete-user-text"}
        />}
    </>)
    }
}

export default withRouter(UserTable);
